import DatePicker from 'react-datepicker'

import styles from './Bookings.module.scss'

const BookingsDatepicker = props => (
  <div className={styles.datepickerHolder}>
    <div className={styles.datepickerLabel}>{props.label}</div>
    <DatePicker {...props} className={styles.datepicker} isClearable={true} />
  </div>
)

export default BookingsDatepicker
